// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"630":"code_activation-CodeActivationModal","777":"code_activation-PhoneVerification"}[chunkId] + "." + {"630":"a141120700e2c0228089","777":"6af779932f2381bcc490"}[chunkId] + ".js";
};